import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Configuração do ícone do marcador para corrigir um problema comum do Leaflet/Webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

// Coordenadas centrais aproximadas para os Estados Unidos para o centro inicial
const USA_CENTER_COORDS = [39.8283, -98.5795]; // Centro dos EUA continentais

// Lista de estados e suas coordenadas centrais aproximadas para destaque
const HIGHLIGHT_STATES = [
  { name: "Indiana", coords: [40.2672, -86.1349] },
  // A correção de 'Mexigan' para 'Michigan' já foi feita
  { name: "Michigan", coords: [44.3148, -85.6024] }, 
  { name: "Virginia", coords: [37.4316, -78.4468] },
  // A correção de 'Norht Carolina' para 'North Carolina' já foi feita
  { name: "North Carolina", coords: [35.7596, -79.0193] }, 
  { name: "South Carolina", coords: [33.8361, -81.1637] },
  // A correção de 'New Jersiey' para 'New Jersey' já foi feita
  { name: "New Jersey", coords: [40.0583, -74.4057] }, 
  // A correção de 'Massashusetts' para 'Massachusetts' já foi feita
  { name: "Massachusetts", coords: [42.4072, -71.3824] }, 
  // A correção de 'Tenessy' para 'Tennessee' já foi feita
  { name: "Tennessee", coords: [35.5175, -86.5804] }, 
];

function Map() {
  return (
    <div style={{ padding: "10px" }}>
      {/* Título em inglês */}
      <h2 style={{ textAlign: "center", marginBottom: "15px", color: "#fff" }}>
        🌎 Service Areas
      </h2>
      
      {/* Contêiner do Mapa */}
      <div
        style={{
          width: "100%",
          height: "600px",
          borderRadius: 12,
          overflow: "hidden",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Sombra suave para destacar o mapa
        }}
      >
        <MapContainer
          center={USA_CENTER_COORDS}
          zoom={4}
          style={{ width: "100%", height: "100%" }}
          scrollWheelZoom={true}
        >
          <TileLayer
            attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {HIGHLIGHT_STATES.map((state) => (
            <Marker key={state.name} position={state.coords}>
              <Popup>
                **{state.name}**
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
}

export default Map;